import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-warning\"><path d=\"m3 20 9-16 9 16H3Zm2.295-1.371h13.41L12 6.743 5.295 18.629ZM12 17.539a.682.682 0 0 0 .511-.213.726.726 0 0 0 .206-.526.726.726 0 0 0-.206-.526.684.684 0 0 0-.511-.213.684.684 0 0 0-.511.213.726.726 0 0 0-.206.526c0 .21.068.385.206.526a.684.684 0 0 0 .511.212Zm-.666-2.392h1.332v-4.571h-1.332v4.571Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol